import { render, staticRenderFns } from "./InvestmentUnitsDialog.vue?vue&type=template&id=203e0842&scoped=true&"
import script from "./InvestmentUnitsDialog.vue?vue&type=script&lang=js&"
export * from "./InvestmentUnitsDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentUnitsDialog.vue?vue&type=style&index=0&id=203e0842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e0842",
  null
  
)

export default component.exports